module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-row"
  }, [_c('span', [_c('i', {
    staticClass: "kp-panel-jump"
  }), _vm._v(_vm._s(_vm.$t('general.labels.jump')))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('add-button'), _vm._v(" "), _c('remove-button', {
    attrs: {
      "index": _vm.index,
      "jump-id": _vm.jumpId
    }
  })], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-9e094696!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/jump/Header.vue
 ** module id = 889
 ** module chunks = 1
 **/